var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 17h-1v-2H5v2H4v-7c0-.552.449-1 1-1v2h14V9c.551 0 1 .448 1 1v7zm-3 4H7v-4h10v4zm5-11c0-1.654-1.346-3-3-3h-2v2H7V7H5c-1.654 0-3 1.346-3 3v9h3v4h14v-4h3v-9zM7 2h10v4h2V0H5v6h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.2b7a04a20c2c3982352874db553c32ec.svg";
export { ForwardRef as ReactComponent };